import React from "react";

const SvgEmptyIcon = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width || "1em"}
      height={width || "1em"}
      viewBox="0 0 100 100"
      style={style}
      fill="currentColor"
    >
      <defs />
      <defs>
        <clipPath id="a">
          <path d="M0 0h100v100H0z" />
        </clipPath>
      </defs>
      <g data-name="empty – 1">
        <g clip-path="url(#a)" data-name="Group 19867">
          <path
            stroke="#bdbebe"
            d="M86.742 16.2l8.483-8.479a2.083 2.083 0 10-2.946-2.946L83.8 13.258A49.918 49.918 0 0013.258 83.8l-8.479 8.475a2.085 2.085 0 000 2.946 2.063 2.063 0 001.471.612 2.092 2.092 0 001.475-.608l8.475-8.479A49.918 49.918 0 0086.742 16.2zM4.167 50A45.754 45.754 0 0180.85 16.2L16.2 80.85A45.6 45.6 0 014.167 50zM50 95.833A45.6 45.6 0 0119.15 83.8L83.8 19.15A45.754 45.754 0 0150 95.833z"
            data-name="Path 38533"
          />
        </g>
      </g>
    </svg>
  );
};

export default SvgEmptyIcon;
